import React from "react";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import { AssementButton } from "../../atom";

const AssessmentQuestionList = ({
  questions = [],
  clusterQuestions = {},
  showClusters,
  userRole,
  studentRole,
  onQuestionClick,
  isFlagged,
}) => {
  const renderQuestion = (question, index, label) => (
    <Grid item key={question?.id ?? index}>
      <Box sx={{ display: "flex", alignItems: "center", minHeight: 40 }}>
        <AssementButton
          onButtonClick={() => onQuestionClick(question, index)}
          btncolor={question?.is_correct ? "#28B882" : "#d06060"}
          text={label}
        />
        <Box sx={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {userRole === studentRole && isFlagged(question) && (
            <Tooltip title="Flagged for review" arrow>
              <FlagIcon sx={{ color: "#FFB200", fontSize: 20 }} aria-label="Flagged for review" />
            </Tooltip>
          )}
        </Box>
      </Box>
    </Grid>
  );

  if (!showClusters) {
    return (
      <Grid container rowGap={2} columnGap={2} sx={{ paddingInlineStart: 3 }}>
        {questions.map((question, index) => renderQuestion(question, index, index + 1))}
      </Grid>
    );
  }

  return Object.entries(clusterQuestions).map(([clusterName, cluster]) => (
    <Box key={clusterName} sx={{ mb: 3 }}>
      <Typography sx={{ fontWeight: 700, mb: 1 }}>{clusterName}</Typography>
      <Grid container rowGap={2} columnGap={2} sx={{ paddingInlineStart: 3 }}>
        {cluster.map((question) => {
          const index = questions.findIndex((item) => String(item.id) === String(question.id));
          return renderQuestion(question, index, question.display_order);
        })}
      </Grid>
    </Box>
  ));
};

export default AssessmentQuestionList;